import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AiFillYoutube,
  AiFillFacebook,  
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  const { t } = useTranslation();
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Container className="footer-inner">
        <Row className="footer-top">
          <Col md={4} className="footer-col">
            <h3 className="footer-heading">{t("footer.brandName")}</h3>
          </Col>

          <Col md={4} className="footer-col">
            <h3 className="footer-heading">{t("footer.contact")}</h3>
            <div className="footer-item">
              <a className="footer-link" href="mailto:info@choicestfruit.com">
                info@choicestfruit.com
              </a>
            </div>
            <div className="footer-item">{t("footer.location")}</div>
          </Col>

          <Col md={4} className="footer-col">
            <h3 className="footer-heading">{t("footer.policies")}</h3>
            <ul className="footer-links" aria-label={t("footer.a11y.policies")}> 
              <li>
                <Link className="footer-link" to="/policies/grievance-appeals">
                  {t("footer.grievanceAppeals")}
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/policies/privacy">
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link className="footer-link" to="/policies/terms">
                  {t("footer.terms")}
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col md={6} className="footer-col footer-copyright">
            <div className="footer-item">{t("footer.copyright", { year })}</div>
          </Col>
          <Col md={6} className="footer-col footer-social">
            <ul className="footer-icons" aria-label={t("footer.a11y.socialLinks")}>
              <li className="social-icons">
                <a
                  href="https://www.youtube.com/@ChoicestFruit"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.youtube")}
                >
                  <AiFillYoutube />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100083371838989"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.facebook")}
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/choicest-fruit/"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("footer.a11y.linkedin")}
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Footer;
